import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import NotFound from "../../components/not-found/NotFound";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import { Link, useSearchParams } from "react-router-dom";
import IconButton from "../../components/Button/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BlockIcon from "@mui/icons-material/Block";
import Switch from "../../components/Switch/Switch";
import { SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { DatePicker, Select } from "../../components/Form";
import { toast } from "sonner";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useDebounce from "../../hooks/useDebounce";
// import { getOrderApi } from '../../services/orderManagement'
// import { SiMicrosoftexcel } from "react-icons/si";
import profileImage from "../../Assests/image/profile_not_found.png";
import { user } from "../../routes/route";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import {
    Completed_callAPi,
    FailedConsulatationApi,
    getLogsHistoryApi,
    getUserHistoryApi,
    getUserListApi,
    logoutUserFromAllDevice,
    Missed_callAPi,
    sendOtpAPi,
    waitlistApi,
    //   verifyOtpApi,
} from "../../services/userManagement";
import { fetchSessionBreakdownApi } from "../../services/sessionBreakdown";
import findSerialNumber from "../../utils/findSerialNumber";

import { toastMessage } from '../../utils/toastMessage'
import { fatchCategoryApi } from '../../services/categoryManagement'
import { charLimit } from '../../utils/charLimit'
import common from '../../routes/common'
import UserStatus from "../userManagement/UserStatus";
import { dateFormat, dateFormatUtc, formatDuration, dateFormatWithTime } from '../../utils/dateFormat'
import { ConsultationCount, gender } from '../../utils/genderList'
import scrollToUp from '../../utils/scrollToUp'
import { CapitalizeFirstWord } from '../../utils/CapitalizeFirstWord'
import Loader from '../../comman/Loader'
import useDownloadWithPassword from '../../hooks/useDownloadWithPassword'
import csv from '../../Assests/image/csv.svg'
import useButtonLoader from '../../hooks/UseButtonLoader'
import ModalBox from '../../components/modal/ModalBox'
import { useOTPModalCNF } from '../../hooks/useOTPModalCNF'
import { Box, FormControl, InputLabel, Select as MuiSelect, MenuItem, TextField, Typography } from "@mui/material";
import constants from "../../utils/constants";
import ChatBox from '../../components/chatBox/ChatBox';
import { getChatHistoryApi } from '../../services/supportManagement';
import DownloadIcon from "@mui/icons-material/Download";
import ChatIcon from "@mui/icons-material/Chat";
import GetAppIcon from "@mui/icons-material/GetApp";
import { CustomTabs, CustomTab } from "../../components/tabs/Tabs";
import SectionLoaderOverlay from "../../components/loader/SectionLoaderOverlay";

// Exotel is the source of truth: legacy Exotel calls may have mode="chat".
// A null/missing/empty callModeCourier is treated as chat.
const getAdminConsultationMode = (consultation) =>
    String(consultation?.session_info?.callModeCourier || "").toLowerCase() === "exotel"
        ? "call"
        : "chat";

// Utility function to calculate age from date of birth
const calculateAge = (dateOfBirth) => {
    if (!dateOfBirth) return "---";
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    if (age < 0) {
        return "---";
    }

    return age;
};

// Utility function to get consultation count label
const getConsultationCountLabel = (count) => {
    if (!count || count === 0) return "---";
    if (count === 1) return "1st";
    if (count === 2) return "2nd";
    if (count === 3) return "3rd";
    return "Repeat"; // 4 and above
};

const getConsultationRecordingUrl = (consultation = {}) => (
    consultation?.recordingUrl ||
    consultation?.recording_url ||
    consultation?.callRecordingUrl ||
    consultation?.onCompletion?.recordingUrl ||
    consultation?.onCompletion?.recording_url ||
    consultation?.onCompletion?.callRecordingUrl ||
    consultation?.session_info?.recordingUrl ||
    consultation?.session_info?.recording_url ||
    consultation?.session_info?.callRecordingUrl ||
    consultation?.session_info?.sessionMeta?.recordingUrl ||
    consultation?.session_info?.sessionMeta?.recording_url ||
    ""
);

const { USER_DETAIL, USER_DELETE } = user;
const { NOT_FOUND } = common;


// console.log('Gender', gender)

function LogCard({ log }) {
    const [expanded, setExpanded] = React.useState(false);
    const data = log?.logData || {};
    const isBad = data.speedKbps !== undefined && data.speedKbps !== null && data.speedKbps < 5;
    const isWarn = data.responseTimeMs !== undefined && data.responseTimeMs !== null && data.responseTimeMs > 2000;
    function formatTimeHHMMSS(iso) {
        if (!iso) return '--:--:--';
        const d = new Date(iso);
        return d.toLocaleTimeString('en-GB', { hour12: false });
    }
    return (
        <div className={`log-timeline-card${isBad ? ' log-card-bad' : isWarn ? ' log-card-warning' : ''}`}>
            <div className="log-main-row">
                <span className="log-dot" />
                <span className="log-time">{formatTimeHHMMSS(log.createdAt)}</span>
                <span className="log-type">{data.type ? (data.type.charAt(0).toUpperCase() + data.type.slice(1)) : ''}</span>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '21px', marginTop: '7px' }}>
                <div>
                    <span className="log-section-label">Speed: </span>
                    <span className={'log-section-value ' + (isBad ? 'log-red' : '')}>{data.speedKbps !== undefined && data.speedKbps !== null ? `${data.speedKbps} kbps` : '--'}</span>
                </div>
                <div>
                    <span className="log-section-label">Resp: </span>
                    <span className={'log-section-value ' + (isWarn ? 'log-card-warning' : '')}>{data.responseTimeMs !== undefined && data.responseTimeMs !== null ? `${data.responseTimeMs} ms` : '--'}</span>
                </div>
                {/* <div>
          <span className="log-section-label">Internet: </span>
          <span className={'log-section-value ' + (data.isInternetReachable ? 'log-green':'log-red')}>
            {data.isInternetReachable ? 'Yes' : 'No'}
          </span>
        </div> */}
                {data.carrier && (
                    <div>
                        <span className="log-section-label">Carrier: </span>
                        <span className="log-section-value">{data.carrier}</span>
                    </div>
                )}
                {data.strength !== undefined && (
                    <div>
                        <span className="log-section-label">Strength: </span>
                        <span className="log-section-value">{data.strength}</span>
                    </div>
                )}
            </div>
            <div className="log-card-actions">
                <button className="log-more-btn" onClick={() => setExpanded(!expanded)}>
                    {expanded ? "Show Less" : "Show More"}
                </button>
            </div>
            {expanded && (
                <div className="log-card-raw">
                    {JSON.stringify(data, null, 2)}
                </div>
            )}
        </div>
    );
}

const getUniqueSessionLogs = (logs = []) => {
  const seen = new Set();
  return logs.filter((log) => {
    const dataKey = log.logData ? JSON.stringify(log.logData) : '';
    const key = [
      log.logType || '',
      log.callStatus || '',
      dataKey,
    ].join('|');

    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

const CompleteConstulation = ({ queryOnly = false }) => {
    const [managementTab, setManagementTab] = useState(0);
    const isQuerySection = queryOnly;
    const sectionTitle = isQuerySection ? "Completed Queries" : "Completed Call/Chat";

    const handleManagementTabChange = (_event, value) => {
        setManagementTab(value);
        setActivePage(1);
    };
    // Log modal states
    const [logsModalOpen, setLogsModalOpen] = useState(false);
    const [logsLoading, setLogsLoading] = useState(false);
    const [logs, setLogs] = useState([]);
    const [userLogs, setUserLogs] = useState([]); // left
    const [consultantLogs, setConsultantLogs] = useState([]); // right
    const [logsError, setLogsError] = useState("");
    const [logsForId, setLogsForId] = useState("");

    // Breakdown modal states
    const [breakdownModalOpen, setBreakdownModalOpen] = useState(false);
    const [breakdownLoading, setBreakdownLoading] = useState(false);
    const [breakdownData, setBreakdownData] = useState(null);

    // View logs handler
    const handleViewLogs = async (waitlistId) => {
        setLogsForId(waitlistId);
        setLogsError("");
        setLogs([]);
        setLogsLoading(true);
        try {
            const res = await getLogsHistoryApi({ waitlistId });
            let logsArr = res.data?.data?.logs || []

            console.log('logsArr  logs===>',res.data?.data?.logs)
            const decoratedLogs = getUniqueSessionLogs(logsArr).map(l => ({ ...l, showDetails: false }));
            setLogs(decoratedLogs);
            setUserLogs(decoratedLogs.filter(l => l.logType === 'user_session_tracking'));
            setConsultantLogs(decoratedLogs.filter(l => l.logType === 'consultant_session_tracking'));
            setLogsModalOpen(true);
            setLogsError(logsArr.length === 0 ? (res?.message || "No logs found.") : "");
        } catch (err) {
            setLogsError(err?.message || "Failed to fetch logs.");
            setLogs([]);
        } finally {
            setLogsLoading(false);
        }
    };

    // Close logs modal
    const handleCloseLogsModal = () => {
        setLogsModalOpen(false);
        setLogs([]);
        setLogsError("");
        setLogsForId("");
    };

    const handleViewBreakdown = async (sessionId) => {
        if (!sessionId) {
            toastMessage("Invalid session ID", "error", "breakdown");
            return;
        }
        setBreakdownModalOpen(true);
        setBreakdownLoading(true);
        setBreakdownData(null);
        try {
            const res = await fetchSessionBreakdownApi(sessionId);
            if (res.data.code === 200) {
                setBreakdownData(res.data.data);
            } else {
                toastMessage(res.data.message || "Failed to fetch breakdown", "error", "breakdown");
                setBreakdownModalOpen(false);
            }
        } catch (err) {
            toastMessage("Error fetching breakdown", "error", "breakdown");
            setBreakdownModalOpen(false);
        } finally {
            setBreakdownLoading(false);
        }
    };

    const API_URL = constants.SERVER_API
    const [searchParam, setSearchParam] = useSearchParams()
    const { open: openCNFModal, OTPModalCNF } = useOTPModalCNF();
    const [activePage, setActivePage] = useState(1);
    const [pageLimit, setPageLimit] = useState(10); // Add page limit state
    const [search, setSearch] = useState(
        ""
    );
    const debounceValue = useDebounce(search || "", 300);
    const [total, setTotal] = useState(0);
    const [userList, setUserList] = useState([]);
    const [isListLoading, setIsListLoading] = useState(false);
    const [problemList, setProblemList] = useState([]);
    const [statusModal, setStatusModal] = useState(false);
    const [statusValue, setStatusValue] = useState("");
    const [statusId, setStatusId] = useState("");
    const [logoutUserModel, setLogoutUserModel] = useState(false);

    const [buttonref, buttonLoader] = useButtonLoader("Logout");

    const [WriteOtpModal, setwriteOtpModal] = useState(false);

    // Chat modal states
    const [chatModal, setChatModal] = useState(false);
    const [selectedThreadId, setSelectedThreadId] = useState(null);
    const [selectedUserName, setSelectedUserName] = useState("");
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedRecordingUrl, setSelectedRecordingUrl] = useState("");
    const [selectedOrderId, setSelectedOrderId] = useState("");
    const [selectedConsultationMode, setSelectedConsultationMode] = useState("");
    const [downloadingChat, setDownloadingChat] = useState(false);

    // Filter states
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [userGender, setUserGender] = useState("");
    const [consultationMode, setConsultationMode] = useState("");
    const [consultationType, setConsultationType] = useState("");
    const [problem, setProblem] = useState("");
    const [consultantGender, setConsultantGender] = useState("");
    const [consultantName, setConsultantName] = useState("");
    const [consultantAge, setConsultantAge] = useState("");
    const [remedySent, setRemedySent] = useState("");
    const [consultationCount, setConsultationCount] = useState("");
    const [totalConsultations, setTotalConsultations] = useState("");

    // Time range filter states
    const [timeRange, setTimeRange] = useState(searchParam.get("timeRange") || "");
    const [timeRangeStartDate, setTimeRangeStartDate] = useState(searchParam.get("timeRangeStartDate") || "");
    const [timeRangeEndDate, setTimeRangeEndDate] = useState(searchParam.get("timeRangeEndDate") || "");

    // Time range options
    const timeRangeOptions = [
        { value: "today", label: "Today" },
        { value: "yesterday", label: "Yesterday" },
        { value: "last7days", label: "Last 7 Days" },
        { value: "last30days", label: "Last 30 Days" },
        { value: "thisMonth", label: "This Month" },
        { value: "lastMonth", label: "Last Month" },
        { value: "custom", label: "Custom Range" }
    ];

    // Page limit options
    const pageLimitOptions = [
        { value: 5, label: "5 per page" },
        { value: 10, label: "10 per page" },
        { value: 25, label: "25 per page" },
        { value: 50, label: "50 per page" },
        { value: 100, label: "100 per page" }
    ];

    // URL params
    // const genderValue = searchParam.get("gender") || "";
    // const consultationCountValue = searchParam.get("ConsultationCount") || "";
    // const registrationDate = searchParam.get("registrationDate") || "";
    // const problemValue = searchParam.get("problem") || "";

    // useEffect(() => {
    //     setLocalStorage("userList", "search", search);
    // }, [search]);

    const handleLogoutHandler = async () => {
        try {
            buttonLoader(true);
            const sendData = { userId: statusId };
            const { data } = await logoutUserFromAllDevice(sendData);
            if (data.code === 200) {
                console.log("Date", data);
                logoutCloseModel();
            } else {
                toastMessage(data.message, "error", "userList");
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            buttonLoader(false);
        }
    };

    // handle all hooks
    const { loading, requestDownload, requestDownloadWithCallback, DownloadPasswordModal } = useDownloadWithPassword();

    const [loader, showLoader, hideLoader] = useFullPageLoader();

    const handleExcelDownload = () => {
        try {
            const url = `${API_URL}/admin/user/download/completed`;
            const params = {
                filter: {
                    usedFor: isQuerySection ? "query" : "private_call"
                }
            };

            // Add all current filters to the export
            if (search) {
                params.filter.search = search;
            }
            if (startDate) {
                params.filter.startDate = dateFormatUtc(startDate);
            }
            if (endDate) {
                params.filter.endDate = dateFormatUtc(endDate);
            }
            if (userGender) {
                params.filter.userGender = userGender;
            }
            if (consultationMode) {
                params.filter.consultationMode = consultationMode;
            }
            if (consultationType) {
                params.filter.consultationType = consultationType;
            }
            if (problem) {
                params.filter.problem = problem;
            }
            if (consultantGender) {
                params.filter.consultantGender = consultantGender;
            }
            if (consultantName && consultantName.trim()) {
                params.filter.consultantSearch = consultantName.trim();
            }
            if (consultantAge) {
                params.filter.consultantAge = consultantAge;
            }
            if (remedySent) {
                params.filter.remedySent = remedySent;
            }
            // Note: consultationCount and totalConsultations filters are applied client-side
            // as backend doesn't support them yet
            // if (consultationCount) {
            //     params.filter.consultationCount = consultationCount;
            // }
            // if (totalConsultations) {
            //     params.filter.totalConsultations = totalConsultations;
            // }
            if (timeRange) {
                params.filter.timeRange = timeRange;
            }
            if (timeRangeStartDate) {
                params.filter.timeRangeStartDate = timeRangeStartDate;
            }
            if (timeRangeEndDate) {
                params.filter.timeRangeEndDate = timeRangeEndDate;
            }

            requestDownload(url, `completed-consultations-${dateFormat(new Date())}.csv`, params);
        } catch (e) {
            console.log(e.message);
        }
    };
    //*********Handel status********* */
    const statusUpdateHandler = (id, status) => {
        setStatusModal(true);
        setStatusId(id);
        setStatusValue(status);
    };

    //*********Logout handler function********* */
    const userLogoutHandler = (id) => {
        setStatusId(id);
        setLogoutUserModel(true);
    };

    // gender handler

    const genderHandler = (value) => {
        setUserGender(value);
    };
    // Problem handler

    const problemValueHandler = (value) => {
        setProblem(value);
    };
    // consultation count handler

    const TotalconsultationHandler = (value) => {
        setConsultationMode(value);
    };

    //*********Handel Pagination********* */
    const handlePageChange = (event) => {
        setActivePage(event);
        getUserList(event);
    };

    //*********Handle Page Limit Change********* */
    const handlePageLimitChange = (event) => {
        const newLimit = parseInt(event.target.value);
        setPageLimit(newLimit);
        setActivePage(1); // Reset to first page when changing limit
    };
    //*********Handel refresh icon********* */
    const refreshHandler = (event) => {
        setSearch("");
        setActivePage(1);
        setPageLimit(10); // Reset page limit to default
        setStartDate(null);
        setEndDate(null);
        setUserGender("");
        setConsultationMode("");
        setConsultationType("");
        setProblem("");
        setConsultantGender("");
        setConsultantName("");
        setConsultantAge("");
        setRemedySent("");
        setConsultationCount("");
        setTotalConsultations("");
        setTimeRange("");
        setTimeRangeStartDate("");
        setTimeRangeEndDate("");
        // searchParam.delete("page");
        // searchParam.delete("gender");
        // searchParam.delete("problem");
        // searchParam.delete("registrationDate");
        // searchParam.delete("ConsultationCount");
        // searchParam.delete("startDate");
        // searchParam.delete("endDate");
        // searchParam.delete("userAge");
        // searchParam.delete("userGender");
        // searchParam.delete("consultationMode");
        // searchParam.delete("consultationType");
        // searchParam.delete("consultantGender");
        // searchParam.delete("remedySent");
        // searchParam.delete("timeRange");
        // searchParam.delete("timeRangeStartDate");
        // searchParam.delete("timeRangeEndDate");
        getUserList();
    };
    //------------------usre-listing-Api----------------------------------
    const getUserList = async (page = 1) => {
        try {
            setIsListLoading(true);
            const sendData = {
                page: `${page}`,
                limit: `${pageLimit}`,
                filter: {
                    usedFor: isQuerySection ? "query" : "private_call"
                }
            };
            if (!isQuerySection) {
                sendData.filter.customerType = ["normal", "potential", "power"][managementTab] || "normal";
            }
            let filter = {}
            if (search) {
                sendData.filter.search = search;
            }
            if (startDate) {
                sendData.filter.startDate = dateFormatUtc(startDate);
            }
            if (endDate) {
                sendData.filter.endDate = dateFormatUtc(endDate);
            }
            if (userGender) {
                sendData.filter.userGender = userGender;
            }
            if (consultationMode) {
                sendData.filter.consultationMode = consultationMode;
            }
            if (consultationType) {
                sendData.filter.consultationType = consultationType;
            }
            if (problem) {
                sendData.filter.problem = problem;
            }
            if (consultantGender) {
                sendData.filter.consultantGender = consultantGender;
            }
            if (consultantName && consultantName.trim()) {
                sendData.filter.consultantSearch = consultantName.trim();
            }
            if (consultantAge) {
                sendData.filter.consultantAge = consultantAge;
            }
            if (remedySent) {
                sendData.filter.remedySent = remedySent;
            }
            // Backend now supports consultationCount and totalConsultations filters
            if (consultationCount) {
                sendData.filter.consultationCount = consultationCount;
            }
            if (totalConsultations) {
                sendData.filter.totalConsultations = totalConsultations;
            }
            if (timeRange) {
                sendData.filter.timeRange = timeRange;
            }
            if (timeRangeStartDate) {
                sendData.filter.timeRangeStartDate = timeRangeStartDate;
            }
            if (timeRangeEndDate) {
                sendData.filter.timeRangeEndDate = timeRangeEndDate;
            }

            const { data } = await Completed_callAPi(sendData);
            if (data.code === 200) {
                console.log('data ===>', data.result.list)
                console.log("remainingCoins ===>");

                let userListData = data?.result?.list || [];
                const originalTotal = data?.result?.total || 0;

                // Calculate consultation count and total consultations for each user if not provided by backend
                // Backend should provide these, but we'll calculate as fallback
                if (userListData.length > 0) {
                    // Group consultations by user_id
                    const userConsultationsMap = new Map();
                    userListData.forEach(consultation => {
                        const userId = consultation.user_id;
                        if (!userConsultationsMap.has(userId)) {
                            userConsultationsMap.set(userId, []);
                        }
                        userConsultationsMap.get(userId).push(consultation);
                    });

                    // Sort each user's consultations by createdAt and assign count
                    userConsultationsMap.forEach((consultations, userId) => {
                        consultations.sort((a, b) => {
                            const dateA = new Date(a.createdAt || 0);
                            const dateB = new Date(b.createdAt || 0);
                            return dateA - dateB;
                        });

                        const totalCount = consultations.length;
                        consultations.forEach((consultation, index) => {
                            if (!consultation.consultationCount && !consultation.consultation_number) {
                                consultation.consultationCount = index + 1;
                            }
                            if (!consultation.totalConsultations) {
                                consultation.totalConsultations = totalCount;
                            }
                        });
                    });

                }

                setUserList(userListData);
                setTotal(originalTotal);
                // scrollToUp();
            } else {
                setUserList([]);
                setTotal(0);
                toastMessage(data.message, "error", "userList");
            }
        } catch (error) {
            console.log("error", error);
            setUserList([]);
            setTotal(0);
            const errorMessage = error?.response?.data?.message || error?.message || "Failed to fetch consultations";
            toastMessage(errorMessage, "error", "userList");
        } finally {
            setIsListLoading(false);
        }
    };

    const closeModel = () => {
        setStatusModal(false);
        setStatusValue("");
        setStatusId("");
    };

    const logoutCloseModel = () => {
        setLogoutUserModel(false);
        setStatusId("");
    };

    // problem list handler function

    const fetchProblemHandler = async () => {
        try {
            const { data } = await fatchCategoryApi();
            if (data.code === 200) {
                setProblemList(data?.result?.categoryList || []);
            } else {
                setProblemList([]);
                toastMessage(data.message, "error", "categoryList");
            }
        } catch (error) {
            console.log("error", error);
        }
    };



    const handleRegistrationDate = (date) => {
        const utcDateString = dateFormatUtc(date);
        searchParam.delete("page");
        searchParam.set("registrationDate", utcDateString);
        setSearchParam(searchParam);
    };

    // Time range handler
    const handleTimeRangeChange = (value) => {
        setTimeRange(value);
        if (value !== 'custom') {
            setTimeRangeStartDate("");
            setTimeRangeEndDate("");
        }
    };

    // Time range date change handler
    const handleTimeRangeDateChange = (type, value) => {
        if (type === 'start') {
            setTimeRangeStartDate(value);
        } else {
            setTimeRangeEndDate(value);
        }
    };

    // Apply filter function
    const applyFilter = () => {
        setActivePage(1); // Reset to page 1 when applying filters
        getUserList(1);
    };

    // View all chats between user and consultant
    const handleViewAllChats = async (userId, consultantId, userName, currentThreadId, currentConsultation = null) => {
        if (!userId || !consultantId) {
            toastMessage("User or consultant information is missing", "error", "chat");
            return;
        }

        const recordingUrl = getConsultationRecordingUrl(currentConsultation || {});

        // If we have a current threadId, open immediately for faster response
        if (currentThreadId || recordingUrl) {
            setSelectedThreadId(currentThreadId || null);
            setSelectedUserName(`${userName || "User"} - All Chats`);
            setSelectedUserId(userId);
            setSelectedRecordingUrl(recordingUrl);
            setSelectedOrderId(currentConsultation?.orderId || "");
            setSelectedConsultationMode(getAdminConsultationMode(currentConsultation));
            setChatModal(true);
            return;
        }

        // Only fetch if no threadId available
        try {
            showLoader();
            // Fetch consultations with filter for faster response
            const response = await Completed_callAPi({
                page: "1",
                limit: "100",
                filter: {
                    userId: userId,
                    consultantId: consultantId
                }
            });

            if (response?.data?.code === 200) {
                let consultations = response?.data?.result?.list || [];
                // Filter consultations for this specific user-consultant pair
                consultations = consultations.filter(consultation =>
                    consultation.user_id === userId && consultation.consultant_id === consultantId && consultation.threadId
                );

                if (consultations.length === 0) {
                    toastMessage("No chats found between this user and consultant", "error", "chat");
                    hideLoader();
                    return;
                }

                // Get the first threadId to show
                const firstThreadId = consultations[0]?.threadId;

                if (firstThreadId) {
                    setSelectedThreadId(firstThreadId);
                    setSelectedUserName(`${userName || "User"} - All Chats`);
                    setSelectedUserId(userId);
                    setSelectedRecordingUrl("");
                    setSelectedOrderId("");
                    setSelectedConsultationMode("");
                    setChatModal(true);
                } else {
                    toastMessage("No chat available", "error", "chat");
                }
            } else {
                toastMessage("Failed to fetch chats", "error", "chat");
            }
        } catch (error) {
            console.error("Error fetching all chats:", error);
            toastMessage("Failed to fetch chats", "error", "chat");
        } finally {
            hideLoader();
        }
    };

    // View single order chat only
    const handleViewOrderChat = (consultation) => {
        const threadId = consultation?.threadId;
        const recordingUrl = getConsultationRecordingUrl(consultation);
        const isAudioConsultation = getAdminConsultationMode(consultation) === "call";

        if (threadId || recordingUrl) {
            setSelectedThreadId(isAudioConsultation && recordingUrl ? null : threadId);
            setSelectedUserName(`${consultation?.request_form?.firstName || consultation?.userDetails?.userId || "User"} - ${consultation?.createdAt ? dateFormat(new Date(consultation.createdAt)) : "Consultation"}`);
            setSelectedUserId(consultation?.user_id);
            setSelectedRecordingUrl(recordingUrl);
            setSelectedOrderId(consultation?.orderId || "");
            setSelectedConsultationMode(getAdminConsultationMode(consultation));
            setChatModal(true);
        } else {
            toastMessage("No chat or recording available for this consultation", "error", "chat");
        }
    };

    const handleCloseChatModal = () => {
        setChatModal(false);
        setSelectedThreadId(null);
        setSelectedUserName("");
        setSelectedUserId(null);
        setSelectedRecordingUrl("");
        setSelectedOrderId("");
        setSelectedConsultationMode("");
    };

    // Download specific chat for this consultation
    const handleDownloadChat = async (threadId, userName, consultationDate) => {
        if (!threadId) {
            toastMessage("No chat available for this consultation", "error", "chat");
            return;
        }

        try {
            setDownloadingChat(true);
            showLoader();

            // Fetch all chat messages
            let allMessages = [];
            let currentPage = 1;
            let hasMore = true;
            let maxPages = 50; // Safety limit to prevent infinite loops
            let pageCount = 0;

            while (hasMore && pageCount < maxPages) {
                const response = await getChatHistoryApi({
                    threadId,
                    page: currentPage,
                    limit: 100
                });

                // Check if response exists and has data
                if (!response || !response.data) {
                    console.error("Invalid response from getChatHistoryApi:", response);
                    hasMore = false;
                    break;
                }

                // Handle different response structures
                if (response.data.code === 200 || response.data.success === true) {
                    const messages = response.data.result?.messages || response.data.result?.list || response.data.messages || [];

                    if (messages.length > 0) {
                        allMessages = [...allMessages, ...messages];
                    }

                    const totalPages = response.data.result?.totalPages || response.data.totalPages || 1;
                    hasMore = currentPage < totalPages && messages.length > 0;
                    currentPage++;
                    pageCount++;
                } else {
                    // If first page fails, show error
                    if (currentPage === 1) {
                        const errorMsg = response.data.message || "Failed to fetch chat messages";
                        toastMessage(errorMsg, "error", "chat");
                        return;
                    }
                    hasMore = false;
                }
            }

            if (allMessages.length === 0) {
                toastMessage("No messages found in this chat", "error", "chat");
                return;
            }

            // Format messages for CSV
            const csvRows = [
                ["Timestamp", "Sender", "Message", "Type"]
            ];

            allMessages.forEach(msg => {
                try {
                    const timestamp = msg?.createdAt ? dateFormatWithTime(msg.createdAt) : (msg?.timestamp ? dateFormatWithTime(msg.timestamp) : "---");
                    const sender = msg?.from?.name || msg?.senderName || msg?.sender?.name || "Unknown";
                    let messageText = "";
                    let messageType = "Text";

                    // Handle different message type formats
                    const msgType = msg?.type || msg?.messageType || 1;
                    const fileUrl = msg?.metadata?.fileUrl || msg?.fileUrl || msg?.media?.url || "";

                    if ((msgType === "audio" || msgType === 3) && fileUrl) {
                        messageText = `Audio: ${fileUrl}`;
                        messageType = "Audio";
                    } else if ((msgType === "image" || msgType === 2) && fileUrl) {
                        messageText = `Image: ${fileUrl}`;
                        messageType = "Image";
                    } else if ((msgType === "file" || msgType === 5) && fileUrl) {
                        messageText = `File: ${fileUrl}`;
                        messageType = "File";
                    } else {
                        messageText = msg?.message || msg?.text || msg?.content || "---";
                        messageType = "Text";
                    }

                    // Clean message text for CSV
                    const cleanMessage = String(messageText).replace(/"/g, '""').replace(/\n/g, ' ').replace(/\r/g, '');

                    csvRows.push([
                        timestamp,
                        sender,
                        cleanMessage,
                        messageType
                    ]);
                } catch (err) {
                    console.error("Error formatting message:", err, msg);
                    // Skip invalid messages
                }
            });

            if (csvRows.length <= 1) {
                toastMessage("No valid messages to download", "error", "chat");
                return;
            }

            // Convert to CSV string
            const csvContent = csvRows.map(row =>
                row.map(cell => {
                    const cellStr = String(cell || '');
                    return `"${cellStr.replace(/"/g, '""')}"`;
                }).join(',')
            ).join('\n');

            // Create and download file
            const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const blobUrl = window.URL.createObjectURL(blob);
            const fileName = `chat-${(userName || 'consultation').replace(/[^a-z0-9]/gi, '_')}-${(consultationDate || dateFormat(new Date())).replace(/[^a-z0-9]/gi, '_')}.csv`;

            link.setAttribute('href', blobUrl);
            link.setAttribute('download', fileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);

            toastMessage(`Chat downloaded successfully (${allMessages.length} messages)`, "success", "chat");
        } catch (error) {
            console.error("Error downloading chat:", error);
            const errorMsg = error?.message || error?.response?.data?.message || "Failed to download chat";
            toastMessage(errorMsg, "error", "chat");
        } finally {
            setDownloadingChat(false);
            hideLoader();
        }
    };

    // Download all chats between user and consultant
    const handleDownloadAllChats = async (userId, consultantId, userName, consultantName) => {
        if (!userId || !consultantId) {
            toastMessage("User or consultant information is missing", "error", "chat");
            return;
        }

        try {
            setDownloadingChat(true);
            showLoader();

            // Fetch all consultations - we'll filter client-side since API might not support these filters
            // For better performance, we could add a backend endpoint, but for now we'll fetch and filter
            const response = await Completed_callAPi({
                page: "1",
                limit: "1000",
                filter: {}
            });

            if (response?.data?.code === 200) {
                let consultations = response?.data?.result?.list || [];

                // Filter consultations for this specific user-consultant pair
                consultations = consultations.filter(consultation =>
                    consultation.user_id === userId && consultation.consultant_id === consultantId
                );

                if (consultations.length === 0) {
                    toastMessage("No consultations found between this user and consultant", "error", "chat");
                    return;
                }

                // Collect all messages from all consultations
                let allMessages = [];

                for (const consultation of consultations) {
                    if (consultation.threadId) {
                        let currentPage = 1;
                        let hasMore = true;

                        while (hasMore) {
                            try {
                                const chatResponse = await getChatHistoryApi({
                                    threadId: consultation.threadId,
                                    page: currentPage,
                                    limit: 100
                                });

                                // Check if response exists and has data
                                if (!chatResponse || !chatResponse.data) {
                                    console.error("Invalid response from getChatHistoryApi:", chatResponse);
                                    hasMore = false;
                                    break;
                                }

                                // Handle different response structures
                                if (chatResponse.data.code === 200 || chatResponse.data.success === true) {
                                    const messages = chatResponse.data.result?.messages || chatResponse.data.result?.list || chatResponse.data.messages || [];

                                    if (messages.length > 0) {
                                        // Add consultation context to each message
                                        const messagesWithContext = messages.map(msg => ({
                                            ...msg,
                                            consultationDate: consultation.createdAt,
                                            consultationId: consultation._id
                                        }));
                                        allMessages = [...allMessages, ...messagesWithContext];
                                    }

                                    const totalPages = chatResponse.data.result?.totalPages || chatResponse.data.totalPages || 1;
                                    hasMore = currentPage < totalPages && messages.length > 0;
                                    currentPage++;
                                } else {
                                    hasMore = false;
                                }
                            } catch (error) {
                                console.error(`Error fetching chat for consultation ${consultation._id}:`, error);
                                hasMore = false;
                            }
                        }
                    }
                }

                if (allMessages.length === 0) {
                    toastMessage("No chat messages found", "error", "chat");
                    return;
                }

                // Sort messages by timestamp
                allMessages.sort((a, b) => {
                    const dateA = new Date(a.createdAt || 0);
                    const dateB = new Date(b.createdAt || 0);
                    return dateA - dateB;
                });

                // Format messages for CSV
                const csvRows = [
                    ["Consultation Date", "Timestamp", "Sender", "Message", "Type"]
                ];

                allMessages.forEach(msg => {
                    try {
                        const consultationDate = msg.consultationDate ? dateFormat(new Date(msg.consultationDate)) : "---";
                        const timestamp = msg?.createdAt ? dateFormatWithTime(msg.createdAt) : (msg?.timestamp ? dateFormatWithTime(msg.timestamp) : "---");
                        const sender = msg?.from?.name || msg?.senderName || msg?.sender?.name || "Unknown";
                        let messageText = "";
                        let messageType = "Text";

                        // Handle different message type formats
                        const msgType = msg?.type || msg?.messageType || 1;
                        const fileUrl = msg?.metadata?.fileUrl || msg?.fileUrl || msg?.media?.url || "";

                        if ((msgType === "audio" || msgType === 3) && fileUrl) {
                            messageText = `Audio: ${fileUrl}`;
                            messageType = "Audio";
                        } else if ((msgType === "image" || msgType === 2) && fileUrl) {
                            messageText = `Image: ${fileUrl}`;
                            messageType = "Image";
                        } else if ((msgType === "file" || msgType === 5) && fileUrl) {
                            messageText = `File: ${fileUrl}`;
                            messageType = "File";
                        } else {
                            messageText = msg?.message || msg?.text || msg?.content || msg?.body || "---";
                            messageType = "Text";
                        }

                        // Clean message text for CSV
                        const cleanMessage = String(messageText).replace(/"/g, '""').replace(/\n/g, ' ').replace(/\r/g, '');

                        csvRows.push([
                            consultationDate,
                            timestamp,
                            sender,
                            cleanMessage,
                            messageType
                        ]);
                    } catch (err) {
                        console.error("Error formatting message:", err, msg);
                        // Skip invalid messages
                    }
                });

                if (csvRows.length <= 1) {
                    toastMessage("No valid messages to download", "error", "chat");
                    return;
                }

                // Convert to CSV string
                const csvContent = csvRows.map(row =>
                    row.map(cell => {
                        const cellStr = String(cell || '');
                        return `"${cellStr.replace(/"/g, '""')}"`;
                    }).join(',')
                ).join('\n');

                // Create and download file
                const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                const blobUrl = window.URL.createObjectURL(blob);
                const fileName = `all-chats-${userName || 'user'}-${consultantName || 'consultant'}-${dateFormat(new Date())}.csv`;

                link.setAttribute('href', blobUrl);
                link.setAttribute('download', fileName);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);

                toastMessage(`All chats downloaded successfully (${allMessages.length} messages)`, "success", "chat");
            } else {
                toastMessage("Failed to fetch consultations", "error", "chat");
            }
        } catch (error) {
            console.error("Error downloading all chats:", error);
            toastMessage("Failed to download all chats", "error", "chat");
        } finally {
            setDownloadingChat(false);
            hideLoader();
        }
    };

    // useEffect(() => {
    //   if (debounceValue) {
    //     searchParam.set('query', debounceValue)
    //   } else {
    //     searchParam.delete('query')
    //   }
    //   if (activePage === 1) {
    //     searchParam.delete('page')
    //   }
    //   setSearchParam(searchParam)
    //   getOrder(activePage, debounceValue)
    // }, [searchParam, debounceValue])

    useEffect(() => {

    }, [searchParam, debounceValue]);

    useEffect(() => {
        if (managementTab >= 0 && managementTab <= 2) {
            getUserList(activePage);
            fetchProblemHandler();
        }
    }, [activePage, pageLimit, managementTab]);

    return (
        <>
            <OTPModalCNF verifiedHandle={() => {
                console.log('OTP Verified Successfully!')
            }} />
            <DownloadPasswordModal />
            {loader}
            <div className="WrapperArea">
                <div className="WrapperBox">
                    <div className="TitleBox">
                        {/* <div className="user_management_heading"> */}
                        <h4 className="Title">{sectionTitle}</h4>
                        <div className="block_user_button">
                            <SecondaryButton
                                onClick={handleExcelDownload}
                                disabled={loading}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '8px 16px',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }}
                            >
                                {loading ? (
                                    <Loader />
                                ) : (
                                    <>
                                        <div className="csv-image-wrapper" style={{ width: '16px', height: '16px' }}>
                                            <img src={csv} alt="csv file download" style={{ width: '100%', height: '100%' }} />
                                        </div>
                                        Export CSV
                                    </>
                                )}
                            </SecondaryButton>
                            {/* <div className="mx-2">
                <Link to={`${USER_DELETE}`}>
                  <div className="block_user_button">
                    <button
                    // onClick={() => setAddConsultantModel(true)}
                    >
                      {/* <AddIcon /> */}
                            {/* Deleted User
                    </button>
                  </div>
                </Link>
              </div>  */}
                        </div>
                        {/* </div> */}
                    </div>
                    {!queryOnly && (
                        <Box sx={{ width: "100%", mb: 2 }}>
                            <CustomTabs value={managementTab} onChange={handleManagementTabChange}>
                                <CustomTab label="Normal Customers" />
                                <CustomTab label="Potential Power Customers" />
                                <CustomTab label="Power Customers" />
                            </CustomTabs>
                        </Box>
                    )}
                    <div className="FilterBox FilterArea" style={{ flexDirection: 'column' }}>
                        {/* Row 1: Search Bar and Basic Filters */}
                        <div className="group_filter_value" style={{
                            marginBottom: '15px',
                            display: 'flex !important',
                            flexWrap: 'wrap !important',
                            gap: '15px',
                            alignItems: 'center',
                            width: '100%',
                            flexDirection: 'row'
                        }}>
                            {/* Search Bar */}
                            <div className="form-group search_md_size userSearch" style={{ minWidth: '200px', flex: '1 1 auto' }}>
                                <input
                                    type="search"
                                    className={`form-control ${search && "active"}`}
                                    placeholder="Search name, mobile, User ID (VM…)"
                                    value={search || ""}
                                    style={{ "--color": "#FF8989" }}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>

                            {/* User Gender */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                <Select
                                    className={`form-control ${userGender && "active"}`}
                                    value={userGender}
                                    onChange={(e) => setUserGender(e.target.value)}
                                >
                                    <option value="">User Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="other">Other</option>
                                </Select>
                            </div>

                            {/* Mode of Consultation */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto', display: queryOnly ? 'none' : undefined }}>
                                <Select
                                    className={`form-control ${consultationMode && "active"}`}
                                    value={consultationMode}
                                    onChange={(e) => setConsultationMode(e.target.value)}
                                >
                                    <option value="">Mode of Consultation</option>
                                    <option value="call">Call</option>
                                    <option value="chat">Chat</option>
                                </Select>
                            </div>

                            {/* Type of Consultation */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto', display: queryOnly ? 'none' : undefined }}>
                                <Select
                                    className={`form-control ${consultationType && "active"}`}
                                    value={consultationType}
                                    onChange={(e) => setConsultationType(e.target.value)}
                                >
                                    <option value="">Type of Consultation</option>
                                    <option value="free">Free</option>
                                    <option value="paid">Paid</option>
                                </Select>
                            </div>
                        </div>

                        {/* Row 2: Additional Filters and Time Range */}
                        <div className="group_filter_value" style={{
                            display: 'flex !important',
                            flexWrap: 'wrap !important',
                            gap: '15px',
                            alignItems: 'center',
                            width: '100%',
                            flexDirection: 'row'
                        }}>
                            {/* Problem */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                <Select
                                    className={`form-control ${problem && "active"}`}
                                    value={problem}
                                    onChange={(e) => setProblem(e.target.value)}
                                >
                                    <option value="">Problem</option>
                                    {problemList &&
                                        problemList.length > 0 &&
                                        problemList.map((problemItem, index) => {
                                            return (
                                                <option value={problemItem.title} key={problemItem._id}>
                                                    {problemItem.title}
                                                </option>
                                            );
                                        })}
                                </Select>
                            </div>

                            {/* Consultant Name */}
                            <div className="form-group search_sm_size" style={{ minWidth: '160px', flex: '0 0 auto' }}>
                                <input
                                    type="text"
                                    className={`form-control ${consultantName && "active"}`}
                                    placeholder="Consultant Name"
                                    value={consultantName || ""}
                                    onChange={(e) => setConsultantName(e.target.value)}
                                />
                            </div>

                            {/* Consultant Age */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto', display: queryOnly ? 'none' : undefined }}>
                                <Select
                                    className={`form-control ${consultantAge && "active"}`}
                                    value={consultantAge}
                                    onChange={(e) => setConsultantAge(e.target.value)}
                                >
                                    <option value="">Consultant Age</option>
                                    <option value="18-25">18-25</option>
                                    <option value="26-35">26-35</option>
                                    <option value="36-45">36-45</option>
                                    <option value="46-55">46-55</option>
                                    <option value="56+">56+</option>
                                </Select>
                            </div>

                            {/* Consultant Gender */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto', display: queryOnly ? 'none' : undefined }}>
                                <Select
                                    className={`form-control ${consultantGender && "active"}`}
                                    value={consultantGender}
                                    onChange={(e) => setConsultantGender(e.target.value)}
                                >
                                    <option value="">Consultant Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="other">Other</option>
                                </Select>
                            </div>

                            {/* Remedy Sent */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto', display: queryOnly ? 'none' : undefined }}>
                                <Select
                                    className={`form-control ${remedySent && "active"}`}
                                    value={remedySent}
                                    onChange={(e) => setRemedySent(e.target.value)}
                                >
                                    <option value="">Remedy Sent</option>
                                    <option value="yes">Yes</option>
                                    <option value="no">No</option>
                                </Select>
                            </div>

                            {/* Which Consultation Filter */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto', display: queryOnly ? 'none' : undefined }}>
                                <Select
                                    className={`form-control ${consultationCount && "active"}`}
                                    value={consultationCount}
                                    onChange={(e) => setConsultationCount(e.target.value)}
                                >
                                    <option value="">Which Consultation</option>
                                    <option value="1">1st</option>
                                    <option value="2">2nd</option>
                                    <option value="3">3rd</option>
                                    <option value="repeat">Repeat</option>
                                </Select>
                            </div>

                            {/* Total Consultations Filter */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto', display: queryOnly ? 'none' : undefined }}>
                                <Select
                                    className={`form-control ${totalConsultations && "active"}`}
                                    value={totalConsultations}
                                    onChange={(e) => setTotalConsultations(e.target.value)}
                                >
                                    <option value="">Total Consultations</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                    <option value="17">17</option>
                                    <option value="18">18</option>
                                    <option value="19">19</option>
                                    <option value="20">20</option>
                                </Select>
                            </div>

                            {/* Time Range Filter */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <InputLabel>Time Range</InputLabel>
                                    <MuiSelect
                                        value={timeRange}
                                        onChange={(e) => handleTimeRangeChange(e.target.value)}
                                        label="Time Range"
                                    >
                                        <MenuItem value="">
                                            <em>All Time Ranges</em>
                                        </MenuItem>
                                        {timeRangeOptions.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </MuiSelect>
                                </FormControl>
                            </div>

                            {timeRange === 'custom' && (
                                <>
                                    <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                        <TextField
                                            size="small"
                                            type="date"
                                            variant="outlined"
                                            label="Start Date"
                                            value={timeRangeStartDate}
                                            onChange={(e) => handleTimeRangeDateChange('start', e.target.value)}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </div>
                                    <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                        <TextField
                                            size="small"
                                            type="date"
                                            variant="outlined"
                                            label="End Date"
                                            value={timeRangeEndDate}
                                            onChange={(e) => handleTimeRangeDateChange('end', e.target.value)}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </div>
                                </>
                            )}

                            {/* Apply Filter & Refresh */}
                            <div className="form-group refresh_button" style={{ minWidth: '120px', flex: '0 0 auto', display: 'flex', gap: '10px' }}>
                                <SecondaryButton onClick={applyFilter}>
                                    Apply
                                </SecondaryButton>
                                <SecondaryButton onClick={refreshHandler}>
                                    Clear
                                </SecondaryButton>
                            </div>
                        </div>


                    </div>
                    <div className="content-table" style={{ position: "relative", minHeight: 200 }}>
                        {isListLoading && <SectionLoaderOverlay />}
                        <table>
                            <thead>
                                <tr>
                                    {queryOnly ? (
                                        <>
                                            <th>S. No.</th>
                                            <th>Query Date & Time</th>
                                            <th>User ID</th>
                                            <th>User Name</th>
                                            <th>User Mobile</th>
                                            <th>User Gender</th>
                                            <th>Query / Problem</th>
                                            <th>Consultant Name</th>
                                            <th>Duration</th>
                                            <th>View Chat</th>
                                            <th>Download Chat</th>
                                        </>
                                    ) : (
                                        <>
                                            <th>S. No.</th>
                                            <th>Date of Consultation & Time</th>
                                            <th>User ID</th>
                                            <th>User Name</th>
                                            <th>User Mobile</th>
                                            <th>Mail ID</th>
                                            <th>User Age</th>
                                            <th>User Gender</th>
                                            <th>Mode of Consultation</th>
                                            <th>Type of Consultation</th>
                                            <th>Problem</th>
                                            <th>Duration of Consultation</th>
                                            <th>Amount Paid</th>
                                            <th>Consultant Name</th>
                                            <th>Consultant Number</th>
                                            <th>Consultant Age</th>
                                            <th>Consultant Gender</th>
                                            <th>Which Consultation</th>
                                            <th>Total Consultations</th>
                                            <th>Breakdown</th>
                                            <th>View All Chat</th>
                                            <th>View This Order Chat</th>
                                            <th>Download This Chat</th>
                                            <th>Download All Chats</th>
                                            <th>Customer Type</th>
                                            <th>Power Origin</th>
                                            <th>Power Customer Since</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {userList.length > 0 ? (
                                    userList.map((user, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <tr>
                                                    {queryOnly ? (
                                                        <>
                                                            <td>{findSerialNumber(index, activePage, pageLimit)}</td>
                                                            <td>{dateFormatWithTime(user?.createdAt) || "---"}</td>
                                                            <td><Link to={`${USER_DETAIL}/${user.user_id}`} target="_blank">{user?.userDetails?.userId || "---"}</Link></td>
                                                            <td><Link to={`${USER_DETAIL}/${user.user_id}`} target="_blank">{user?.request_form?.firstName || "---"}</Link></td>
                                                            <td>{user?.userDetails?.mobile || "---"}</td>
                                                            <td>{user?.request_form?.gender ? CapitalizeFirstWord(user.request_form.gender) : "---"}</td>
                                                            <td style={{ minWidth: '220px' }}>{user?.request_form?.concern || "---"}</td>
                                                            <td>
                                                                <Link target="_blank" to={`/consultant-management/consultant-detail/${user.consultant_id}`}>
                                                                    {user?.consultantDetails?.accountName || "---"}
                                                                </Link>
                                                            </td>
                                                            <td>{formatDuration(user?.onCompletion?.callDurationInSeconds) || "---"}</td>
                                                            <td>
                                                                {(user?.threadId || getConsultationRecordingUrl(user)) ? (
                                                                    <IconButton
                                                                        aria-label="view query chat"
                                                                        className="px-2 py-0"
                                                                        onClick={() => handleViewOrderChat(user)}
                                                                        title="View Query Chat"
                                                                    >
                                                                        <VisibilityIcon className="eye_icon" style={{ fontSize: '18px', color: '#2196F3' }} />
                                                                    </IconButton>
                                                                ) : <span style={{ color: '#ccc' }}>---</span>}
                                                            </td>
                                                            <td>
                                                                {user?.threadId ? (
                                                                    <IconButton
                                                                        aria-label="download query chat"
                                                                        className="px-2 py-0"
                                                                        onClick={() => requestDownloadWithCallback(() => handleDownloadChat(
                                                                            user.threadId,
                                                                            user?.request_form?.firstName || user?.userDetails?.userId || "User",
                                                                            user?.createdAt ? dateFormat(new Date(user.createdAt)) : ""
                                                                        ), 'Completed Queries')}
                                                                        title="Download Query Chat"
                                                                        disabled={downloadingChat}
                                                                    >
                                                                        <DownloadIcon style={{ fontSize: '18px', color: downloadingChat ? '#ccc' : '#4CAF50' }} />
                                                                    </IconButton>
                                                                ) : <span style={{ color: '#ccc' }}>---</span>}
                                                            </td>
                                                        </>
                                                    ) : (
                                                        <>
                                                    <td>{findSerialNumber(index, activePage, pageLimit)}</td>
                                                    <td>
                                                        {
                                                            user.logs?.find(log => log.callBy === "user")
                                                                ? dateFormat(new Date(user.logs.find(log => log.callBy === "user").timestamp))
                                                                : dateFormat(user.createdAt) || "---"
                                                        }
                                                    </td>
                                                    <td> <Link to={`${USER_DETAIL}/${user.user_id}`} target="_blank">{user?.userDetails?.userId || "---"}</Link></td>
                                                    <td> <Link to={`${USER_DETAIL}/${user.user_id}`} target="_blank">{user?.request_form?.firstName || "---"}</Link></td>
                                                    <td>{user?.userDetails?.mobile || "---"}</td>
                                                    <td>{user?.userDetails?.email || "---"}</td>
                                                    <td>{calculateAge(user.request_form?.dateOfBirth)}</td>
                                                    <td>
                                                        {user.request_form?.gender
                                                            ? CapitalizeFirstWord(user.request_form?.gender)
                                                            : "---"}
                                                    </td>
                                                    <td>{CapitalizeFirstWord(getAdminConsultationMode(user))}</td>
                                                    <td>{user?.coupon?.code === "FREE5MINUTES" ? "Free" : "Paid"}</td>
                                                    <td>{user?.request_form?.concern || "---"}</td>
                                                    <td>{formatDuration(user?.onCompletion?.callDurationInSeconds) || "---"}</td>
                                                    <td>{user?.onCompletion?.amountToDeduct.toFixed(2) || "---"}</td>
                                                    <td> <Link target="_blank"
                                                        to={`/consultant-management/consultant-detail/${user.consultant_id}`}
                                                    >{user?.consultantDetails?.accountName || "---"}</Link></td>
                                                    <td>{user?.consultantDetails?.mobile || "---"}</td>
                                                    <td>{calculateAge(user?.consultantDetails?.dateOfBirth)}</td>
                                                    <td>
                                                        {user?.consultantDetails?.gender
                                                            ? CapitalizeFirstWord(user?.consultantDetails?.gender)
                                                            : "---"}
                                                    </td>
                                                    {/* Which Consultation Column (1st, 2nd, 3rd, Repeat) */}
                                                    <td>
                                                        {getConsultationCountLabel(user?.consultationCount || user?.consultation_number)}
                                                    </td>
                                                    <td>
                                                        {user?.totalConsultations || "---"}
                                                    </td>
                                                    {/* Breakdown Column */}
                                                    <td>
                                                        <div className="action_button" style={{ display: 'flex', justifyContent: 'center' }}>
                                                            <IconButton
                                                                aria-label="view breakdown"
                                                                className="px-2 py-0"
                                                                onClick={() => handleViewBreakdown(user?._id)}
                                                                title="View Session Breakdown"
                                                            >
                                                                <VisibilityIcon className="eye_icon" style={{ fontSize: '18px', color: '#9c27b0' }} />
                                                            </IconButton>
                                                        </div>
                                                    </td>
                                                    {/* View All Chat Column */}
                                                    <td>
                                                        <div className="action_button" style={{ display: 'flex', justifyContent: 'center' }}>
                                                            <IconButton
                                                                aria-label="view all chats"
                                                                className="px-2 py-0"
                                                                onClick={() => handleViewAllChats(
                                                                    user?.user_id,
                                                                    user?.consultant_id,
                                                                    user?.request_form?.firstName || user?.userDetails?.userId || "User",
                                                                    user?.threadId,
                                                                    user
                                                                )}
                                                                title="View All Chats"
                                                            >
                                                                <ChatIcon className="eye_icon" style={{ fontSize: '18px', color: '#FF8989' }} />
                                                            </IconButton>
                                                        </div>
                                                    </td>
                                                    {/* View This Order Chat Column */}
                                                    <td>
                                                        <div className="action_button" style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
                                                            {(user?.threadId || getConsultationRecordingUrl(user)) ? (
                                                                <IconButton
                                                                    aria-label="view order chat"
                                                                    className="px-2 py-0"
                                                                    onClick={() => handleViewOrderChat(user)}
                                                                    title={getConsultationRecordingUrl(user) ? "View Chat / Recording" : "View This Order Chat"}
                                                                >
                                                                    <VisibilityIcon className="eye_icon" style={{ fontSize: '18px', color: '#2196F3' }} />
                                                                </IconButton>
                                                            ) : (
                                                                <span style={{ color: '#ccc' }}>---</span>
                                                            )}

                                                            {/* View Logs Button */}
                                                            <IconButton
                                                                aria-label="view consultation logs"
                                                                className="px-2 py-0"
                                                                onClick={() => handleViewLogs(user._id)}
                                                                title="View Logs"
                                                            >
                                                                <ViewListRoundedIcon style={{ fontSize: '18px', color: '#607d8b' }} />
                                                            </IconButton>
                                                        </div>
                                                    </td>
                                                    {/* Download This Chat Column */}
                                                    <td>
                                                        <div className="action_button" style={{ display: 'flex', justifyContent: 'center' }}>
                                                            {(getAdminConsultationMode(user) === "chat" && user?.threadId) ? (
                                                                <IconButton
                                                                    aria-label="download chat"
                                                                    className="px-2 py-0"
                                                                    onClick={() => requestDownloadWithCallback(() => handleDownloadChat(
                                                                        user?.threadId,
                                                                        user?.request_form?.firstName || user?.userDetails?.userId || "User",
                                                                        user?.createdAt ? dateFormat(new Date(user.createdAt)) : ""
                                                                    ), 'Completed Consultations (Chat)')}
                                                                    title="Download This Chat"
                                                                    disabled={downloadingChat}
                                                                >
                                                                    <DownloadIcon style={{ fontSize: '18px', color: downloadingChat ? '#ccc' : '#4CAF50' }} />
                                                                </IconButton>
                                                            ) : (
                                                                <span style={{ color: '#ccc' }}>---</span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    {/* Download All Chats Column */}
                                                    <td>
                                                        <div className="action_button" style={{ display: 'flex', justifyContent: 'center' }}>
                                                            <IconButton
                                                                aria-label="download all chats"
                                                                className="px-2 py-0"
                                                                onClick={() => requestDownloadWithCallback(() => handleDownloadAllChats(
                                                                    user?.user_id,
                                                                    user?.consultant_id,
                                                                    user?.request_form?.firstName || user?.userDetails?.userId || "User",
                                                                    user?.consultantDetails?.accountName || "Consultant"
                                                                ), 'Completed Consultations (All Chats)')}
                                                                title="Download All Chats with Consultant"
                                                                disabled={downloadingChat}
                                                            >
                                                                <GetAppIcon style={{ fontSize: '18px', color: downloadingChat ? '#ccc' : '#2196F3' }} />
                                                            </IconButton>
                                                        </div>
                                                    </td>
                                                    <td>{user?.customerType || "---"}</td>
                                                    <td>{user?.powerOrigin || "---"}</td>
                                                    <td>{user?.powerCustomerSince ? dateFormatWithTime(user.powerCustomerSince) : "---"}</td>
                                                        </>
                                                    )}

                                                    {/* <td>
                            <div className="action_button">
                              <Link to={`${USER_DETAIL}/${user._id}`}>
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                >
                                  <VisibilityIcon className="eye_icon" />
                                </IconButton>
                              </Link>

                              <Switch
                                checked={user.status}
                                onChange={() =>
                                  statusUpdateHandler(user._id, user.status)
                                }
                              />
                            </div>
                          </td> */}
                                                    {/* <td>
                            <div className="block_user_button">
                              <button
                                className="mx-4"
                                onClick={() => userLogoutHandler(user._id)}
                              // ref={buttonref}
                              >
                                Logout
                              </button>
                            </div>
                          </td> */}
                                                </tr>
                                            </React.Fragment>
                                        );
                                    })
                                ) : (
                                    <NotFound
                                        cols={queryOnly ? 11 : 27}
                                        msg={queryOnly ? "No completed queries found!" : "User not found!"}
                                        icon={NOT_FOUND}
                                        loader={loader}
                                    />
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="pagination-wrapper mt-4 d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                            <Typography variant="body2" color="textSecondary">
                                Show:
                            </Typography>
                            <select
                                value={pageLimit}
                                onChange={(e) => handlePageLimitChange(e)}
                                style={{
                                    padding: '8px 12px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    fontSize: '14px',
                                    minWidth: '80px'
                                }}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                            <Typography variant="body2" color="textSecondary">
                                per page
                            </Typography>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <Typography variant="body2" color="textSecondary">
                                Showing {((activePage - 1) * pageLimit) + 1} to {Math.min(activePage * pageLimit, total)} of {total} items
                            </Typography>
                        </div>

                        {total > pageLimit && (
                            <div className="Pagination">
                                <Pagination
                                    activePage={activePage}
                                    itemsCountPerPage={pageLimit}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {statusModal && (
                <UserStatus
                    show={statusModal}
                    close={closeModel}
                    setListing={setUserList}
                    setUserDetail={""}
                    status={statusValue}
                    id={statusId}
                />
            )}

            {logoutUserModel && (
                <ModalBox
                    status={logoutUserModel}
                    onClose={logoutCloseModel}
                    title="Logout User from all Device"
                    description="Do you want to logout the user from all the devices?"
                    action={handleLogoutHandler}
                    ref={buttonref}
                />
            )}

            {/* Consultation Logs Modal with Timeline UI */}
            <style>{`
                .timeline-logs-modal { display: flex; gap: 36px; padding: 0 4px 0 0; min-width: 660px; }
                .timeline-col { flex: 1 1 0; min-width: 300px; background: #f7fafc; border-radius: 12px; box-shadow: 0 6px 38px #0001; display: flex; flex-direction: column; height: 480px; }
                .timeline-header { position: sticky; top: 0; background: #f7fafc; z-index: 2; padding: 18px 0 8px 0; text-align: center; font-weight: 600; font-size: 1.14em; color: #3854ab; border-bottom: 1px solid #ececec; }
                .timeline-header.consultant { color: #1e8c29; }
                .timeline-scroll { overflow-y: auto; padding: 0 10px 18px 10px; flex: 1 1 0; }
                .log-timeline-card { border: 1.5px solid #e5e7eb; background: #fff; border-radius: 9px; margin: 18px 0 10px 0; padding: 13px 15px; transition: box-shadow .13s; box-shadow: 0 3px 8px #ddd2; }
                .log-card-bad { border-color: #eb4949!important; background: #fff5f2!important; }
                .log-card-warning { border-color: #face6d!important; background: #fffceb!important; }
                .log-main-row { display: flex; align-items: center; gap: 22px; font-size: 16px; }
                .log-time { font-size: 14px; color: #444; width: 70px; }
                .log-dot { width: 10px; height: 10px; border-radius: 50%; background: #347fc6; display: inline-block; }
                .log-type { font-size: 13px; color: #717070; background: #e5e7eb; border-radius: 12px; padding: 0 10px; margin-left: 4px; }
                .log-section-label { font-size: 12px; color: #222; font-weight: 500; }
                .log-section-value { font-size: 14px; color: #333; font-weight: 400; }
                .log-green { color: #127b34; }
                .log-red { color: #b22020; }
                .log-card-actions { margin-top: 6px; }
                .log-more-btn { border: none; background: none; color: #257aff; font-size: 13px; cursor: pointer; margin-top: 2px; padding: 0; }
                .log-card-raw { background: #f4f7fa; border: 1px solid #dee3f0; border-radius: 6px; margin-top: 9px; font-family: 'fira mono', mono; font-size: 13px; color: #616174; white-space: pre-wrap; overflow-x: auto; padding: 10px; }
                @media (max-width: 820px) {
                  .timeline-logs-modal { flex-direction: column; }
                  .timeline-col { min-width: 0; }
                }
                .breakdown-modal-content h4 { margin: 15px 0 10px; border-bottom: 1px solid #eee; padding-bottom: 5px; color: #1a1a2e; }
                .breakdown-row { display: flex; justify-content: space-between; margin-bottom: 6px; font-size: 14px; }
                .breakdown-row span { color: #666; }
                .breakdown-section { margin-bottom: 20px; }
                `}</style>

            {logsModalOpen && (
                <ModalBox
                    status={logsModalOpen}
                    onClose={handleCloseLogsModal}
                    closeIcon
                    size="md"
                    title="Consultation Logs"
                    description=""
                    custom={true}
                >
                    {logsLoading ? (
                        <div style={{ padding: '28px', textAlign: 'center' }}>Loading logs...</div>
                    ) : logsError ? (
                        <div style={{ padding: '24px', color: '#f44336', textAlign: 'center' }}>{logsError}</div>
                    ) : (
                        <div className="timeline-logs-modal">
                            {/* User Session Logs */}
                            <div className="timeline-col">
                                <div className="timeline-header">User Session Logs</div>
                                <div className="timeline-scroll">
                                    {userLogs.length === 0 ?
                                        <div style={{ color: '#888', textAlign: 'center', marginTop: '65px' }}>No User Logs</div>
                                        : userLogs
                                            .map((log, idx) => <LogCard key={log._id || idx} log={log} />)}
                                </div>
                            </div>
                            {/* Consultant Session Logs */}
                            <div className="timeline-col">
                                <div className="timeline-header consultant">Consultant Session Logs</div>
                                <div className="timeline-scroll">
                                    {consultantLogs.length === 0 ?
                                        <div style={{ color: '#888', textAlign: 'center', marginTop: '65px' }}>No Consultant Logs</div>
                                        : consultantLogs
                                            .map((log, idx) => <LogCard key={log._id || idx} log={log} />)}
                                </div>
                            </div>
                        </div>
                    )}
                </ModalBox>
            )}

            {breakdownModalOpen && (
                <ModalBox
                    status={breakdownModalOpen}
                    onClose={() => setBreakdownModalOpen(false)}
                    closeIcon
                    size="md"
                    title="Session Breakdown"
                    custom={true}
                    noFooter={true}
                >
                    {breakdownLoading ? (
                        <div style={{ padding: '28px', textAlign: 'center' }}>Loading breakdown...</div>
                    ) : breakdownData ? (
                        <div className="breakdown-modal-content" style={{ padding: '20px' }}>
                            <div className="breakdown-section">
                                <h4>Session Info</h4>
                                <div className="breakdown-row">
                                    <span>Session ID:</span> <strong>{breakdownData.sessionId}</strong>
                                </div>
                                <div className="breakdown-row">
                                    <span>Status:</span> <strong>{breakdownData.status}</strong>
                                </div>
                                <div className="breakdown-row">
                                    <span>Mode:</span> <strong>{breakdownData.callType}</strong>
                                </div>
                            </div>

                            <div className="breakdown-section">
                                <h4>Duration Breakdown</h4>
                                <div className="breakdown-row">
                                    <span>Total Duration:</span> <strong>{breakdownData.duration.total.minutes} min ({breakdownData.duration.total.seconds} sec)</strong>
                                </div>
                                <div className="breakdown-row">
                                    <span>Offer Portion:</span> <strong>{breakdownData.duration.offer.minutes} min</strong>
                                </div>
                                <div className="breakdown-row">
                                    <span>Extension Portion:</span> <strong>{breakdownData.duration.extension.minutes} min</strong>
                                </div>
                            </div>

                            <div className="breakdown-section">
                                <h4>Pricing & Amounts</h4>
                                <div className="breakdown-row">
                                    <span>Base Rate:</span> <strong>₹{breakdownData.pricing.baseRate}/min</strong>
                                </div>
                                {breakdownData.pricing.hasOffer && (
                                    <div className="breakdown-row">
                                        <span>Offer Rate:</span> <strong>₹{breakdownData.pricing.offerRate}/min</strong>
                                    </div>
                                )}
                                {breakdownData.pricing.hasOffer && breakdownData.duration.offer.minutes > 0 && (
                                    <div className="breakdown-row" style={{ fontStyle: 'italic', marginLeft: '10px', fontSize: '13px' }}>
                                        <span>↳ Offer ({breakdownData.duration.offer.minutes}m @ ₹{breakdownData.pricing.offerRate}/m):</span>
                                        <strong>₹{breakdownData.amounts.offerAmount}</strong>
                                    </div>
                                )}
                                {breakdownData.duration.extension.minutes > 0 && (
                                    <div className="breakdown-row" style={{ fontStyle: 'italic', marginLeft: '10px', fontSize: '13px' }}>
                                        <span>↳ Extension ({breakdownData.duration.extension.minutes}m @ ₹{breakdownData.pricing.baseRate}/m):</span>
                                        <strong>₹{breakdownData.amounts.extensionAmount}</strong>
                                    </div>
                                )}
                                <div className="breakdown-row" style={{ marginTop: '5px', borderTop: '1px dashed #eee', paddingTop: '5px' }}>
                                    <span>Total Amount:</span> <strong>₹{breakdownData.amounts.totalAmount}</strong>
                                </div>
                                <div className="breakdown-row" style={{ color: '#00b894' }}>
                                    <span>Consultant Earned:</span> <strong>₹{breakdownData.amounts.consultantEarned}</strong>
                                </div>
                                <div className="breakdown-row" style={{ color: '#CD2F38' }}>
                                    <span>Platform Fee ({breakdownData.amounts.platformFeeRate}%):</span> <strong>₹{breakdownData.amounts.platformFee}</strong>
                                </div>
                            </div>

                            {breakdownData.coupon && (
                                <div className="breakdown-section coupon-info" style={{ backgroundColor: '#f0f7ff', padding: '10px', borderRadius: '8px' }}>
                                    <h4>{breakdownData.coupon.category === 'OFFER_RULE' ? 'Offer Rule Applied' : 'Coupon Applied'}</h4>
                                    <div className="breakdown-row">
                                        <span>Code/Name:</span> <strong>{breakdownData.coupon.code}</strong>
                                    </div>
                                    <div className="breakdown-row">
                                        <span>Type:</span> <strong>{breakdownData.coupon.type}</strong>
                                    </div>
                                    {breakdownData.coupon.discount > 0 && (
                                        <div className="breakdown-row">
                                            <span>Discount:</span> <strong>{breakdownData.coupon.discount}%</strong>
                                        </div>
                                    )}
                                    {breakdownData.coupon.title && (
                                        <div className="breakdown-row">
                                            <span>Title:</span> <strong>{breakdownData.coupon.title}</strong>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{ padding: '24px', textAlign: 'center' }}>No data available</div>
                    )}
                </ModalBox>
            )}
            {/* LogCard component used inline */}
            {/* Helper for formatting time for timeline cards */}
            {/* Please move below component out to top-level if you want */}
            <></>
            {/* Inline LogCard Component - add this inside your file */}
            {/** Helper for formatting time for timeline cards */}

            {/* Chat Modal */}
            {chatModal && (selectedThreadId || selectedRecordingUrl) && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px'
                }}>
                    <div style={{
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        width: '90%',
                        maxWidth: '800px',
                        maxHeight: '90vh',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative'
                    }}>
                        <div style={{
                            padding: '16px 20px',
                            borderBottom: '1px solid #e0e0e0',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
                                Chat with {selectedUserName}
                            </h3>
                            <button
                                onClick={handleCloseChatModal}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    color: '#666',
                                    padding: '0',
                                    width: '30px',
                                    height: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                ×
                            </button>
                        </div>
                        <div style={{ flex: 1, overflow: 'hidden' }}>
                            <ChatBox
                                threadId={selectedThreadId}
                                userName={selectedUserName}
                                userId={selectedUserId}
                                onClose={handleCloseChatModal}
                                isConsultant={false}
                                recordingUrl={selectedRecordingUrl}
                                orderId={selectedOrderId}
                                consultationMode={selectedConsultationMode}
                            />
                        </div>
                    </div>
                </div>
            )}

        </>
    );
};

export default CompleteConstulation;
